import moment from 'moment'

import validations from 'constants/validations'

const { DATE_SCHEMA_TYPE } = validations

const afterSibling = {
  name: 'afterSibling',
  schemaType: DATE_SCHEMA_TYPE,
  method(options) {
    const message = options.message ?? 'Data inválida'
    const inclusiveSameDay = options.inclusiveSameDay ?? false

    // precisa ser function normal (não arrow) para o yup expor this.parent
    return this.test('afterSibling', message, function (value) {
      const siblingValue = this.parent[options.field]

      if (!value || !siblingValue) return true

      if (
        options.initialValue &&
        moment(value).isSame(moment(options.initialValue), 'day')
      ) {
        return true
      }

      const valueMoment = moment(value).startOf('day')
      const siblingMoment = moment(siblingValue).startOf('day')

      return inclusiveSameDay
        ? valueMoment.isSameOrAfter(siblingMoment)
        : valueMoment.isAfter(siblingMoment)
    })
  },
}

export default afterSibling
